// LIBS
import { ChangeDetectorRef, Component, OnInit, ViewChild, AfterViewInit, inject } from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

// MODELS
import { DSM3SelectOption } from '@eredes/dsm3';
import { DSM34Dialog } from '@eredes/dsm34';
import { ExcelService } from '@eredes/microservices';
import { saveAs } from 'file-saver';

// COMPONENTS
import moment from 'moment';
import { GlobalService } from '../../_core/services/global.service';
import { UserService } from '../../_core/services/user.service';
import { EdpTableComponent } from '../../_shared/edp-table/edp-table.component';
import { EdpTableInterface } from '../../_shared/edp-table/edp-table.interface';
import { GenericModalComponent } from '../../_shared/generic-modal/generic-modal.component';
import { Directory } from '../../_shared/tree/directory';
import { RequestFiltersComponent } from '../request-filters/request-filters.component';

// SERVICES
import { AuthService } from '../../auth/auth.service';
import { RequestPermissionService } from '../request-permission.service';
import { RequestService } from '../request.service';
import { RetailerService } from '../../_core/services/retailer.service';

import { RequestFolder } from './request-folder.helper';

// Helpers
import { RequestListMapExcel } from './request-list-map-excel.helper';

import { Observable, concat, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { RequestPermission } from '../../_core/models/request-permission.model';
import { RetailerModel } from '../../_core/models/retailer.model';
import { RequestStatusModel } from '../models/request-status.model';
import { RequestTypeModel } from '../models/request-type.model';

import { RequestListViewModel } from './request-list.view-model';
import { RequestData } from './request.view-model';

import { EdpResponseBody } from 'app/_core/models/edp-response.model';
import { UserModel } from 'app/_core/models/user.model';
import { GoogleAnalyticsEventsService } from 'app/_core/services/google-analytics-events.service';

@Component({
  selector: 'app-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.scss'],
  standalone: false,
})
export class RequestListComponent extends EdpTableComponent implements OnInit, EdpTableInterface, AfterViewInit {
  @ViewChild('filters') filtersComponent: RequestFiltersComponent;

  breadcrumbTitle: string;

  viewModel: RequestListViewModel = new RequestListViewModel();
  selectPaginationOption: DSM3SelectOption[] = [
    { label: '40', value: '40' },
    { label: '30', value: '30' },
    { label: '20', value: '20' },
    { label: '10', value: '10' },
  ];

  paginationPerPage = 10;
  emptyLabel = 'De momento não existem registos.';
  requestTableData: RequestData = { requests: [] } as RequestData;

  user: UserModel;
  userProfile: any;

  menuList: Directory[];
  isRet: boolean;
  isMngtNotRet: boolean;
  retailersList: RetailerModel[];
  selectRetailer: any = 'pt.edp.retailer.0';
  dataGenericModal: any;
  requestSession: any;

  requestOperationType: string;
  requestTitle: string;
  requestType: string;
  permissions: string[] = [];
  requestOperation = 'pt.edp.request.operation.1';
  endedStatus: string[] = ['pt.edp.request.status.3', 'pt.edp.request.status.4'];

  requestStatusData: RequestStatusModel[];
  requestStatusSelected: [][];

  requestOperationData: RequestTypeModel[];
  requestAreaData: RequestTypeModel[];
  requestDates: [][] = [];

  requestOperationRetSelected: string;
  requestOperationSelected: string;
  requestAreaSelected: string;

  requestFolders: any[];
  requestFolderUniqueCode: string;
  assignableUsers: any[];

  order = 'createdAt';
  direction = 'DESC';

  lookFor: any = '';

  rPermission: RequestPermission;
  isRequestingData = false;

  // CURRENT PAGE
  currentRequestPage = 1;
  count = 0;

  invalidDateInterval = false;
  invalidToBiggerThanFrom = false;
  filtersCtrl = false;

  formGroup: UntypedFormGroup;
  retailersOptions$ = new BehaviorSubject([]);

  public dialog = inject(DSM34Dialog);

  constructor(
    protected requestPermissionService: RequestPermissionService,
    protected retailerService: RetailerService,
    protected requestService: RequestService,
    protected globalService: GlobalService,
    protected userService: UserService,
    public authService: AuthService,
    protected router: Router,
    protected route: ActivatedRoute,
    private readonly fb: UntypedFormBuilder,
    private readonly cdRef: ChangeDetectorRef
  ) {
    super(userService, authService, globalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.createForm();
    this.user = this.userService.getUser();
    this.isRet = this.userService.isProfileRetailer();
    this.isMngtNotRet = this.userService.isInternalMngt();
    if (!this.isRet) {
      this.getRetailers();
    }

    this.route.data.subscribe((data) => {
      this.requestType = data.requestType;
      this.requestOperationType = data.requestOperationType || '';
      this.requestOperationRetSelected = data.requestOperationType || '';
      this.requestTitle = data.requestTitle || '';
      this.breadcrumbTitle = this.requestTitle || 'Listagem';

      if (data.requestOperationType === this.requestOperation) {
        this.requestPermissionService.getCreatePoPermissions().subscribe((permissionData) => {
          this.permissions = permissionData || [];
          this.rPermission = new RequestPermission(this.permissions, true, false, true, true, false);
        });
      } else {
        this.requestPermissionService.getCreatePePermissions().subscribe((permissionData) => {
          this.permissions = permissionData || [];
          this.rPermission = new RequestPermission(this.permissions, true, false, true, true, false);
        });
      }
    });

    this.isRequestingData = true;
    if (!this.isRet) {
      GoogleAnalyticsEventsService.emitEvent(
        'Pedidos',
        'Listagem de Pedidos E-REDES',
        'Visualiza listagem de Pedidos E-REDES'
      );
    } else if (this.requestOperationType === 'pt.edp.request.operation.1,pt.edp.request.operation.2') {
      GoogleAnalyticsEventsService.emitEvent(
        'Histórico',
        'Listagem de Pedidos de Operação e de Esclarecimento',
        'Visualiza listagem de Pedido de Operação e de Esclarecimento'
      );
    }
    this.onControlsChange();
  }

  ngAfterViewInit() {
    this.requestService.getInitialData(this.isRet).subscribe({
      next: (data: any) => {
        if (!this.isRet) {
          this.requestFolders = data[1].Result.Collection;
          this.menuList = new RequestFolder().mapFolders(this.requestFolders);
        }
        this.requestSession = sessionStorage.getItem('savedFilters');
        if (this.requestSession !== null) {
          this.showSessionFilters();
        } else {
          this.refreshData(0);
        }
      },
      error: (err: any) => {
        console.error(err);
        this.isRequestingData = false;
      },
    });
  }

  get inputSearch(): AbstractControl {
    return this.formGroup.get('search');
  }

  get inputDate(): UntypedFormArray {
    return this.formGroup.get('date') as UntypedFormArray;
  }

  get inputStatus(): UntypedFormArray {
    return this.formGroup.get('status') as UntypedFormArray;
  }

  get inputCategory(): AbstractControl {
    return this.formGroup.get('category');
  }

  get inputArea(): AbstractControl {
    return this.formGroup.get('area');
  }

  get inputRetailer(): AbstractControl {
    return this.formGroup.get('retailer');
  }

  /**
   * Creates form for inputs (filters and retailers dropdown - ORD)
   */
  private createForm(): void {
    this.formGroup = this.fb.group({
      search: ['', [], []],
      date: [[], [], []],
      status: this.fb.array([], [], []),
      category: ['', [], []],
      area: ['', [], []],
      retailer: ['', [], []],
    });
  }

  /**
   * Set values when input filters change
   */
  private onControlsChange(): void {
    this.inputCategory.valueChanges.subscribe((value) => {
      this.requestOperationSelected = value;
      this.inputArea.setValue('', { onlySelf: true });
      this.filtersComponent.getAllAreas(value);
    });
    this.inputSearch.valueChanges.subscribe((value) => {
      this.searchTerm = value;
      if (!this.searchTerm) this.valuesFilterChanges();
    });
    this.inputArea.valueChanges.subscribe((value) => (this.requestAreaSelected = value));
    this.inputDate.valueChanges.subscribe((value) => (this.requestDates = value));
    this.inputStatus.valueChanges.subscribe((value) => (this.requestStatusSelected = value));
    this.inputRetailer.valueChanges.subscribe((value) => (this.selectRetailer = value));

    this.valuesFilterChanges();
  }

  valuesFilterChanges(): void {
    this.skip = 0;
    this.currentRequestPage = 1;
    this.setFilters();
    this.applyFilters();
    this.refreshData(0);
  }

  /**
   * Export excel request
   */
  export() {
    this.refreshData(0, null, true);
  }

  refreshData(skip: number, order?: string, excelExport = false) {
    this.isRequestingData = true;

    if (this.count === 0) {
      this.count++;
    } else {
      this.setFilters();
    }

    if (order) {
      if (order !== this.order) {
        this.direction = 'DESC';
      } else {
        this.direction = this.direction === 'ASC' ? 'DESC' : 'ASC';
      }
    } else {
      order = this.order;
    }

    this.order = order;
    const args: any = {
      entity: 'Request',
      retailerUniqueCode: this.userService.getRetailerUniqueCode(),
      skip: skip,
      top: this.paginationPerPage,
      orderby: this.order + ' ' + this.direction,
    };

    const reportArgs: any = {
      entity: 'Request',
      retailerUniqueCode: this.userService.getRetailerUniqueCode(),
      orderby: 'createdAt DESC, requestTransactionDate ASC',
    };

    if (this.requestFolderUniqueCode) {
      args.requestFolderUniqueCode = this.requestFolderUniqueCode;
      reportArgs.requestFolderUniqueCode = this.requestFolderUniqueCode;
    }

    if (this.selectRetailer && this.showRetailerList()) {
      args.retailerUniqueCode = this.selectRetailer;
      reportArgs.retailerUniqueCode = this.selectRetailer;
    }
    // FILTER BY DATE
    if (this.requestDates.length && this.requestDates[0]) {
      args.dateStart = moment(this.requestDates[0])
        .set({ hour: 0, minute: 0, second: 0 })
        .local()
        .format('YYYY-MM-DD HH:mm:ss');
      reportArgs.dateStart = args.dateStart;
    }

    if (this.requestDates.length && this.requestDates[1]) {
      args.dateEnd = moment(this.requestDates[1])
        .set({ hour: 23, minute: 59, second: 59 })
        .local()
        .format('YYYY-MM-DD HH:mm:ss');
      reportArgs.dateEnd = args.dateEnd;
    }

    // FILTER BY STATUS
    const requestStatus = this.requestStatusSelected ? this.requestStatusSelected : [];

    if (requestStatus.length) {
      reportArgs.requestStates = requestStatus.join(' ');
      args.requestStates = reportArgs.requestStates;

      if (reportArgs.requestStates.indexOf('pt.edp.request.status.EDP') >= 0) {
        reportArgs.requestStates = reportArgs.requestStates.replace(
          'pt.edp.request.status.EDP',
          'pt.edp.request.status.1 pt.edp.request.status.2 pt.edp.request.status.6'
        );
        args.requestStates = reportArgs.requestStates;
      }
    }

    // FILTER BY OPERATION RET
    if (this.requestOperationRetSelected) {
      args.requestOperationType = this.requestOperationType;
      reportArgs.requestOperationType = this.requestOperationType;
    }

    // FILTER BY OPERATION ORD
    if (this.requestOperationSelected) {
      args.requestOperationType = this.requestOperationSelected;
      reportArgs.requestOperationType = this.requestOperationSelected;
    }

    // FILTER BY AREA
    if (this.requestAreaSelected) {
      args.requestOperationArea = this.requestAreaSelected;
      reportArgs.requestOperationArea = this.requestAreaSelected;
    }

    // Open Search
    if (this.searchTerm) {
      args.searchTerm = this.searchTerm;
      reportArgs.searchTerm = this.searchTerm;
    }

    if (excelExport) {
      reportArgs.skip = 0;
      reportArgs.top = 1;

      this.globalService
        .callServicePost('pt.edp.comercializadores.request.getReports', reportArgs, {})
        .subscribe((getTotal) => {
          const itemsByPage = 1000;
          const totalPages = Math.ceil(getTotal.Result.TotalCount / itemsByPage);

          const calls$ = new Array<Observable<any>>();
          for (let i = 0; i < totalPages; ++i) {
            reportArgs.skip = i * itemsByPage;
            reportArgs.top = itemsByPage;
            calls$.push(
              this.globalService.callServicePost(
                'pt.edp.comercializadores.request.getReports',
                Object.assign({}, reportArgs),
                {}
              )
            );
          }

          const dataToExport = [];
          concat(...calls$).subscribe({
            next: (res: EdpResponseBody) => {
              dataToExport.push(...res.Result.Collection);
            },
            error: () => {
              this.dataGenericModal = {
                modalTitle: 'Atenção',
                modalText: 'Ocorreu um erro na operação. Tente novamente.',
                btnConfirmText: 'OK',
                error: true,
              };
              this.openGenericDialog(GenericModalComponent);
            },
            complete: () => {
              const filteredData = RequestListMapExcel.mapExcel(dataToExport, this.isRet);
              ExcelService.createFile({
                exportData: filteredData,
                prefixFileName: 'Pedidos_',
                sheetName: 'Pedidos',
              }).then(({ blob, filename }) => saveAs(blob, filename));
            },
          });
        });
    } else {
      this.globalService.callServicePost('pt.edp.comercializadores.request.getHandle', args, {}).subscribe({
        next: (result) => {
          const requests = result.Result.Collection.requests;
          this.requestTableData.requests = requests.Collection;

          this.assignableUsers = result.Result.Collection.assignableUsers.Collection;
          this.uncheckAll();
          this.totalItems = requests.TotalCount;
          this.skip = requests.skip;
          if (this.isRet) {
            this.requestOperationRetSelected = this.requestOperationSelected;
          }
        },
        error: (err) => {
          console.error(err);
          this.requestTableData.requests = [];
          this.isRequestingData = false;
        },
      });
    }
  }

  openNewOperationRequest() {
    this.setFilters();
    this.router.navigate(['create'], { relativeTo: this.route });
  }

  setFolder(requestFolderUniqueCode: string, skip?: number) {
    this.requestFolderUniqueCode = requestFolderUniqueCode;
    if (skip) {
      this.refreshData(skip);
    } else {
      this.refreshData(0);
    }
  }

  getStatusMap(item) {
    if (this.isRet && item.requestStatusUniqueCode === 'pt.edp.request.status.2') {
      return 'Submetido';
    }

    return item.requestStatus;
  }

  /**
   * Sets retailers list
   */
  getRetailers() {
    this.retailerService
      .getRetailers()
      .pipe(
        map((retailersOptions) => {
          const p = [];
          retailersOptions.forEach((result) => {
            p.push({
              label: result.retailerName,
              value: result.retailerUniqueCode,
            });
          });

          return p;
        })
      )
      .subscribe((res) => {
        this.retailersOptions$.next(res);
      });
  }

  /**
   * Check if can see retailers list
   * @returns true or false
   */
  showRetailerList() {
    return this.user.ord && this.user.ord.code === 'pt.edp.retailer.0' && !this.isRet;
  }

  openRequestDetail(uniqueCode: string) {
    this.setFilters();
    this.router.navigate(['detail', uniqueCode], { relativeTo: this.route });
  }

  public assignRequests(assignee?: string) {
    const selectedIds = [];

    this.tableData.forEach(function (obj) {
      if (obj.itemSelected === true) {
        selectedIds.push(obj.requestUniqueCode);

        return true;
      }
    });

    this.requestService.assignTo(assignee, selectedIds).subscribe({
      next: () => {
        this.refreshData(this.skip);
        this.successAssignMessage();
      },
      error: () => {
        this.refreshData(this.skip);
        this.errorAssignMessage();
      },
    });
  }

  showCheck(request: any) {
    // is retailer
    if (this.isRet) {
      return false;
    }

    // request is ended
    if (this.endedStatus.indexOf(request.statusUniqueCode) !== -1) {
      return false;
    }

    // logged user is internalMngt
    if (this.userService.isInternalMngt()) {
      return true;
    }

    // assigned request is null or like logged user
    if (
      request.assignedUserUniqueCode === null ||
      this.userService.getUserUniqueCode() === request.assignedUserUniqueCode
    ) {
      return true;
    }

    return false;
  }

  // OPEN GENERIC MODAL
  // TODO:CONFIG DATA & COMPONENT
  openGenericDialog(component) {}

  // ERROR MESSAGE GENERIC
  errorAssignMessage() {
    this.dataGenericModal = {
      modalTitle: 'Atenção',
      modalText: 'Ocorreu um erro na operação. Tente novamente.',
      btnConfirmText: 'OK',
      error: true,
    };
    this.openGenericDialog(GenericModalComponent);
  }

  // SUCCESS MESSAGE GENERIC
  successAssignMessage() {
    this.dataGenericModal = {
      modalTitle: 'Sucesso',
      modalText: 'Operação concluída.',
      btnConfirmText: 'Ok',
      success: true,
    };
    this.openGenericDialog(GenericModalComponent);
  }

  // SAVE FILTERS IN SESSION STORAGE TO APPLY IN URL
  setFilters() {
    const folder = this.requestFolderUniqueCode || '';
    const retailer = this.isRet
      ? this.selectRetailer || this.user.retailerUniqueCode
      : this.selectRetailer || 'pt.edp.retailer.0';
    const start = this.requestDates.length ? this.requestDates[0] : '';
    const end = this.requestDates.length ? this.requestDates[1] : '';
    const status = this.requestStatusSelected;
    const operation = this.requestOperationSelected;
    const area = this.requestAreaSelected;
    const search = this.searchTerm;
    const page = this.currentRequestPage;

    const savedFilters = {
      currentRequestFolder: folder,
      currentRequestFilterRetailer: retailer,
      currentRequestFilterStart: start,
      currentRequestFilterEnd: end,
      currentRequestFilterStatus: status,
      currentRequestFilterSearch: search,
      currentRequestFilterOperation: operation,
      currentRequestFilterArea: area,
      menuList: this.menuList,
      currentRequestPage: page,
    };
    sessionStorage.setItem('savedFilters', JSON.stringify(savedFilters));
  }

  applyFilters() {
    const data = sessionStorage.getItem('savedFilters');
    const allData = JSON.parse(data);

    const folder = allData.currentRequestFolder;
    const retailer = allData.currentRequestFilterRetailer;
    const status = allData.currentRequestFilterStatus;
    const operation = allData.currentRequestFilterOperation;
    const area = allData.currentRequestFilterArea;
    const search = allData.currentRequestFilterSearch;
    const page = allData.currentRequestPage || 1;

    this.requestFolderUniqueCode = folder;
    this.selectRetailer = retailer;
    this.requestStatusData = status;
    this.requestOperationSelected = operation;
    this.requestAreaData = area;
    this.searchTerm = search;

    if (area) {
      for (const element of this.requestAreaData) {
        if (element.requestOperationSelected) {
          this.requestAreaSelected = element.requestOperationUniqueCode;
        }
      }
    }

    if (folder) {
      this.checkExpendedFolder(folder);
      if (page > 0) {
        this.setFolder(folder, this.currentRequestPage);
      } else {
        this.setFolder(folder);
      }
    }
  }

  /**
   * Apply filters in storage to filters inputs
   */
  showSessionFilters(): void {
    const data = sessionStorage.getItem('savedFilters');
    const allData = JSON.parse(data);

    if (allData.currentRequestFilterOperation) {
      this.inputCategory.setValue(allData.currentRequestFilterOperation, { onlySelf: true });
      if (allData.currentRequestFilterArea) {
        this.inputArea.setValue(allData.currentRequestFilterArea, { onlySelf: true });
      }
    }

    if (allData.currentRequestFilterSearch) {
      this.inputSearch.setValue(allData.currentRequestFilterSearch, { onlySelf: true });
    }

    if (allData.currentRequestFilterRetailer !== 'pt.edp.retailer.0') {
      this.inputRetailer.setValue(allData.currentRequestFilterRetailer, { onlySelf: true });
    }

    if (allData.currentRequestFilterStart && allData.currentRequestFilterEnd) {
      this.inputDate.controls.push(new UntypedFormControl(moment(allData.currentRequestFilterStart).toDate()));
      this.inputDate.controls.push(new UntypedFormControl(moment(allData.currentRequestFilterEnd).toDate()));
      this.inputDate.setValue(
        [moment(allData.currentRequestFilterStart).toDate(), moment(allData.currentRequestFilterEnd).toDate()],
        { onlySelf: true }
      );
    }

    if (allData.currentRequestFilterStatus) {
      allData.currentRequestFilterStatus.forEach((s) => {
        this.inputStatus.controls.push(new UntypedFormControl(s));
      });
      this.inputStatus.setValue(allData.currentRequestFilterStatus, { onlySelf: true });
    }

    this.formGroup.updateValueAndValidity({ emitEvent: true });
    this.cdRef.detectChanges();
  }

  checkExpendedFolder(selectedFolder) {
    for (let i = 0; i < this.menuList.length; i++) {
      if (this.menuList[i].directories.length > 0) {
        for (let h = 0; h < this.menuList[i].directories.length; h++) {
          if (this.menuList[i].directories[h].code === selectedFolder) {
            this.menuList[i].expanded = true;
            this.menuList[i].directories[h].checked = true;
          }
          if (this.menuList[i].directories[h].directories.length > 0) {
            for (let j = 0; j < this.menuList[i].directories[h].directories.length; j++) {
              if (this.menuList[i].directories[h].directories[j].code === selectedFolder) {
                this.menuList[i].expanded = true;
                this.menuList[i].directories[h].expanded = true;
                this.menuList[i].directories[h].directories[j].checked = true;
              }
            }
          }
        }
      }
    }
    this.setFolder(selectedFolder);
  }

  resetSessionFilters() {
    this.count = 0;
    sessionStorage.removeItem('savedFilters');
    this.searchTerm = '';
    this.requestFolderUniqueCode = '';

    // MENULIST
    this.menuList = [];
    this.requestService.getInitialData(this.isRet).subscribe({
      next: (data: any) => {
        if (!this.isRet) {
          this.requestFolders = data[1].Result.Collection;
          this.menuList = new RequestFolder().mapFolders(this.requestFolders);
          this.selectRetailer = 'pt.edp.retailer.0';
        } else {
          this.selectRetailer = this.user.retailerUniqueCode;
        }
      },
      error: (err: any) => {
        console.error(err);
      },
    });
  }

  /**
   * Updates displayed data as pagination change
   * @param event - Object with next page and items per page
   */
  paginationChange(event): void {
    let skip: number;
    this.paginationPerPage = event.itemsPerPage;

    if (event.page !== this.currentRequestPage) {
      this.currentRequestPage = event.page;
      if (event.page > this.currentRequestPage) {
        if (event.page === 1) {
          skip = 0;
        } else {
          skip = (event.page - 1) * this.paginationPerPage;
        }
      } else {
        skip = this.paginationPerPage * (event.page - 1);
      }
    } else {
      skip = 0;
      this.currentRequestPage = 1;
    }
    this.refreshData(skip);
    this.skip = skip;
  }
}
